import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreReducers, CoreState, crypt } from "@reco-m/core";
import { app } from "@reco-w/core-ui";

import { Namespaces as commonNamespaces } from "@reco-w/common-models";
import { Namespaces as userNamespaces } from "@reco-w/auth-user-models";
import { authAccountHttpService } from "@reco-w/auth-service";

import { Namespaces } from "./common";

export namespace passwordModel {
    export const namespace = Namespaces.password;

    export const state: any = freeze(
        {
            ...CoreState,
            password: "",
            code: "",
            confirm: "",
            phone: "",
        },
        !0
    );

    export type StateType = typeof state;
    export const reducers: ReducersMapObject = {
        ...CoreReducers,
        initState() {
            return state;
        },
    };
    export const effects: EffectsMapObject = {
        ...CoreEffects,
        *initPage({ message }, { call, put }) {
            put({ type: "showLoading" });
            try {
                yield put({ type: "initState" });
                yield put({ type: "getAccountMobile", message });
            } catch (e) {
                yield call(message!.error, "initPage：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },

        /**
         * 获取用户手机
         */
        *getAccountMobile({ message }, { select, put, call }) {
            try {
                yield yield put({ type: `${commonNamespaces.memberCommon}/getCertify`, isRefreshUser: true });
                const memberCommonState: any = yield select((state) => state[commonNamespaces.memberCommon]);
                const user = memberCommonState.user;
                const currentUser = user.currentUser;

                yield put({ type: "input", data: { currentUser, phone: currentUser && currentUser.mobile } });
            } catch (e) {
                yield call(message!.error, "getAccountMobile：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },

        /**
         * 发送验证码
         */
        *sendVerifyCode({ delay, data, message }, { call }) {
            const cleardelay = delay();
            try {
                yield call(authAccountHttpService.sendGuestResetPwd, { ...data });
            } catch (e) {
                cleardelay();
                yield call(message!.error, "" + e.errmsg);
            }
        },

        /**
         * 提交
         */
        *submit({ callback, message }, { call, put, select }) {
            try {
                yield put({ type: "input", data: { isSubmit: true } });

                const data = yield select(({ password }) => password),
                    { password, phone, code } = data;

                const cryptPassword = crypt(password);

                yield call(authAccountHttpService.guestResetPwd, {
                    encryMode: server["rsa"]?.enable ? 1 : 0,
                    mobile: phone,
                    code: code,
                    newPassword: cryptPassword,
                    reNewPassword: cryptPassword,
                });
                yield yield put({ type: `${commonNamespaces.memberCommon}/clean` });

                if (callback) {
                    yield put({ type: "input", data: { isSubmit: false } });
                    yield call(callback);
                }
            } catch (e) {
                yield put({ type: "input", data: { isSubmit: false } });
                yield call(message!.error, e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },

        /**
         * 登出
         */
        *logout({ message, success }, { call, put }) {
            try {
                yield yield put({ type: `${commonNamespaces.memberCommon}/clean` });
                yield yield put({ type: `${commonNamespaces.workorderCommon}/clean` });

                yield put({ type: `${userNamespaces.user}/logout`, success });
            } catch (e) {
                yield call(message!.error, e.errmsg);
            }
        },
    };
}

app.model(passwordModel);
